import { FRAMEWORKS } from "@/lib/constants";

export default function Marquee() {
    const items = [...FRAMEWORKS, ...FRAMEWORKS];
    return (
        <section className="relative py-12 lg:py-16 border-y border-navy/10 bg-white/50 overflow-hidden" data-testid="marquee-section">
            <div className="absolute top-4 left-6 lg:left-10 font-mono text-[10px] tracking-[0.28em] uppercase text-navy/40 z-10">
                Aligned With · Global &amp; Indian Frameworks
            </div>
            <div className="marquee-track pt-10">
                {items.map((f, i) => (
                    <span key={i} className="inline-flex items-center gap-8 mx-8">
                        <span className="font-serif text-5xl md:text-7xl lg:text-8xl leading-none tracking-tight text-navy/80 hover:text-gold transition-colors duration-500">
                            {f}
                        </span>
                        <span className="text-gold text-4xl md:text-5xl">·</span>
                    </span>
                ))}
            </div>
        </section>
    );
}
